import React, {useEffect, useState, useCallback} from 'react';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import axios from '../../store/axios-instance';
import SinglePollOption from './SinglePollOption';
import {preventDefaultDrag} from '../../Utils/utils';

export const SinglePoll = ({poll, userId, programId, translation}) => {
    const {question, options, finished} = poll;
    const [voteAvailible, setVoteAvailibility] = useState(false);
    const [readyToCalcVotes, setReadyToCalcVotes] = useState(false);
    const [voteResults, setVoteResults] = useState(null);
    const [userVoted, setUserVoted] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const checkIfUserVoted = useCallback(() => {
        options.forEach((option) => {
            if (option.votes.includes(userId)) setUserVoted(option._id);
        });
    }, [options, userId]);

    const checkIfPollAvailible = useCallback(() => {
        if (!userVoted && !finished) {
            setVoteAvailibility(true);
        } else {
            setReadyToCalcVotes(true);
            setVoteAvailibility(false);
        }
    }, [finished, userVoted]);

    const calcVotes = useCallback(() => {
        const totalVotes = options.reduce((acc, option) => {
            return acc + option.votes.length;
        }, 0);
        const votes = options.map((option) => {
            if (totalVotes === 0) return 0;
            return Math.round((option.votes.length * 100) / totalVotes);
        });
        setVoteResults(votes);
    }, [options]);

    const handleSelect = (id) => {
        if (voteAvailible) setSelectedOption(id);
    };

    const submitVote = () => {
        if (!selectedOption || !voteAvailible) return false;
        axios.post(`/polls/${poll._id}/vote/${selectedOption}`, {programId});
    };

    useEffect(() => {
        checkIfUserVoted();
    }, [checkIfUserVoted, poll]);

    useEffect(() => {
        checkIfPollAvailible();
    }, [checkIfPollAvailible, userVoted]);

    useEffect(() => {
        if (voteResults || !readyToCalcVotes) return;
        calcVotes();
    }, [readyToCalcVotes, calcVotes, voteResults]);

    return (
        <div onDragStart={preventDefaultDrag} className={`poll ${voteAvailible ? '-vote-availible' : ''}`}>
            <div onDragStart={preventDefaultDrag} className="poll_header">
                <p onDragStart={preventDefaultDrag} className="poll_title">
                    {question}
                </p>
                <div onDragStart={preventDefaultDrag} className="poll_status">
                    {finished ? (
                        <>
                            <CheckCircleIcon className="poll_status-icon" />
                            <span>{translation?.polls?.pollClosed || 'Poll closed'}</span>
                        </>
                    ) : (
                        userVoted && (
                            <>
                                <PlayArrowIcon className="poll_status-icon primary-color" />
                                <span>{translation?.polls?.pollProgress || 'Poll in progress'}</span>
                            </>
                        )
                    )}
                </div>
            </div>
            <div onDragStart={preventDefaultDrag} className="poll_body">
                {!!options.length &&
                    options.map((option, index) => (
                        <SinglePollOption
                            key={option._id}
                            option={option}
                            handleSelect={handleSelect}
                            index={index}
                            voteResults={voteResults}
                            selectedOption={selectedOption}
                            userVoted={userVoted}
                            finished={finished}
                            translation={translation}
                        />
                    ))}
                {voteAvailible && (
                    <Button
                        className="poll_button"
                        variant="contained"
                        disabled={!selectedOption}
                        onClick={() => submitVote()}
                    >
                        {translation?.generalText.submit ? translation?.generalText.submit : 'submit'}
                    </Button>
                )}
            </div>
        </div>
    );
};
